
import { gql } from '@apollo/client';

export const GET_ORGANISATION_PERSON_ID_FORMULA = gql`
query Organisation {
    me {
      name
    }
}`;
